import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
import { getResetByTag } from '../../../styles';
var actionButtonStyles = process.env.NODE_ENV === "production" ? {
  name: "qbt5ty",
  styles: "align-self:center"
} : {
  name: "10rmqn5-actionButtonStyles",
  styles: "align-self:center;label:actionButtonStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var resetStyles = getResetByTag('div');
var StyledTileActionButton = /*#__PURE__*/_styled('div', process.env.NODE_ENV === "production" ? {
  target: "e1fshgv60"
} : {
  target: "e1fshgv60",
  label: "StyledTileActionButton"
})(resetStyles, actionButtonStyles);
export default StyledTileActionButton;